// extracted by mini-css-extract-plugin
export default {"wrapper":"_8cVjy","label":"eHWTR","quantityStepper":"k3eFT"};